var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vehicle-list',{attrs:{"organization-id":_vm.organization?.id,"organization-name":_vm.organization?.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }